import { useState, useEffect } from "react";
import { Drawer, Table, Tag, Statistic, Row, Col, Divider } from "antd";
import axios from "axios";

import endpoints from "../../../../utils/endoinpts";

const columns = [
  {
    title: "Nome",
    dataIndex: "name",
  },
  {
    title: "E-mail",
    dataIndex: "email",
  },
  {
    title: "Tipo",
    dataIndex: "recipient_type",
    render: (type) => (type === "guest" ? "Convidado(a)" : "Sócio(a)"),
  },
  {
    title: "Estado",
    dataIndex: "status",
    render: (status) => <Tag color={status === "success" ? "green" : "red"}>{status === "success" ? "Enviado" : "Falhou"}</Tag>,
  },
  {
    title: "Detalhe do erro",
    dataIndex: "error_message",
  },
];

export default function EmailLogs({ data, open, close }) {
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (open && data) {
      handleGetData();
    }
  }, [open, data]);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.communications.emailLogs, { params: { id: data.id } })
      .then((res) => {
        setLogs(res.data.map((item) => ({ ...item, key: item.id })));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  let successCount = logs.filter((item) => item.status === "success").length;
  let errorCount = logs.filter((item) => item.status === "error").length;

  return (
    <Drawer title={`Registo de envios - ${data ? data.subject : ""}`} width={800} onClose={close} open={open}>
      {data && data.status === "pending" ? (
        <p>Esta comunicação ainda não foi enviada, por isso ainda não existe registo de envio.</p>
      ) : (
        <>
          <Row className="mb-4">
            <Col span={8}>
              <Statistic title="Total de destinatários" value={logs.length} />
            </Col>
            <Col span={8}>
              <Statistic title="Enviados com sucesso" value={successCount} valueStyle={{ color: "#3f8600" }} />
            </Col>
            <Col span={8}>
              <Statistic title="Falharam" value={errorCount} valueStyle={{ color: errorCount > 0 ? "#cf1322" : undefined }} />
            </Col>
          </Row>
          <Divider />
          <Table columns={columns} dataSource={logs} loading={isLoading} />
        </>
      )}
    </Drawer>
  );
}
